import TerminalsPage from "./TerminalsPage";
import TerminalsForm from "./TerminalsForm";
import { connect } from "react-redux";
import { mapStateToProps, mapDispatchToProps } from "./Terminals.state";

const ConnectedTerminalsPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(TerminalsPage);

const ConnectedTerminalsForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(TerminalsForm);

export {
  ConnectedTerminalsPage as TerminalsPage,
  ConnectedTerminalsForm as TerminalsForm,
};
